module.exports = __webpack_public_path__ + "img/cooperativeMedia16.89072b81.png";